const SystemAgreementDisplay = () => {
   return (
      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-sm">
         {/* Top Banner - More prominent styling */}
         <div className="bg-yellow-100 border-2 border-yellow-400 p-4 rounded-lg mb-6">
            <div className="">
               <div className="flex-shrink-0 text-center">
                  <svg className="h-6 w-6 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                     <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
               </div>
               <div className="ml-3">
                  <p className="text-base font-medium text-yellow-800">
                     TEMPORARY AGREEMENT NOTICE
                  </p>
                  <p className="text-sm text-yellow-700 mt-1">
                     This agreement display is temporary and will be automatically removed after:
                     <br />1. Final contract signing
                     <br />2. System ownership transfer to DENR-PENRO
                     <br />3. Completion of all legal documentation
                  </p>
               </div>
            </div>
         </div>

         <div className="prose prose-green max-w-none space-y-6">
            {/* Agreement Version */}
            <div className="bg-green-50/50 p-4 rounded-lg">
               <p className="text-gray-800 font-medium">
                  AGREEMENT VERSION: 1.0 | Date: February 15, 2025
               </p>
            </div>

            {/* Legal Protection Notice */}
            <div className="bg-green-50/50 p-4 rounded-lg">
               <p className="text-gray-800 font-medium mb-3">
                  LEGAL PROTECTION NOTICE: This system and all associated intellectual property are protected under the following Philippine laws:
               </p>
               <div className="pl-4 space-y-2">
                  <div className="flex items-start">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">Intellectual Property Code of the Philippines (Republic Act No. 8293, as amended by RA 10372)</p>
                  </div>
                  <div className="flex items-start">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">E-Commerce Act of 2000 (Republic Act No. 8792)</p>
                  </div>
                  <div className="flex items-start">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">Cybercrime Prevention Act of 2012 (Republic Act No. 10175)</p>
                  </div>
                  <div className="flex items-start">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">Data Privacy Act of 2012 (Republic Act No. 10173)</p>
                  </div>
               </div>
               <p className="mt-4 text-gray-700">
                  Any unauthorized use, reproduction, modification, or distribution of this system, its source code, or documentation without explicit written permission from Mark Gilbert Reginio constitutes intellectual property infringement and cybercrime, subject to both civil and criminal penalties under Philippine law. All rights are reserved, and violations will be prosecuted to the fullest extent of the law.
               </p>
            </div>

            {/* Preliminary Notice */}
            <div className="bg-green-50/50 p-4 rounded-lg">
               <p className="text-gray-800 font-medium">
                  PRELIMINARY NOTICE: This is a preliminary agreement outlining the terms of system ownership and usage rights. This document serves to protect both parties' interests during the interim period before the final, notarized agreement is executed. The final agreement will be drafted by legal counsel and will supersede this preliminary agreement.
               </p>
            </div>

            {/* Ownership Notice */}
            <div className="bg-green-50/50 p-4 rounded-lg">
               <p className="text-gray-800 font-medium">
                  OWNERSHIP NOTICE: This system and its source code are the intellectual property of Mark Gilbert Reginio(the DEVELOPER). The system URL may be listed in DENR's systems for reference, but this does not transfer or imply any ownership rights to DENR. Upon contract signing and agreed payment, full ownership rights will transfer to DENR-PENRO.
               </p>
            </div>

            {/* Effectiveness */}
            <div className="bg-green-50/50 p-4 rounded-lg">
               <p className="text-gray-800 font-medium">
                  EFFECTIVENESS: These terms regarding system ownership and usage rights are effective immediately upon system use, regardless of payment status or formal contract signing, and will remain in effect until superseded by the final, notarized agreement.
               </p>
            </div>

            {/* Agreement Title */}
            <h1 className="text-2xl font-bold text-gray-800 my-6 text-center">
               SYSTEM DEVELOPMENT AND TRANSFER AGREEMENT
            </h1>

            {/* Parties */}
            <div className="space-y-4">
               <h2 className="text-xl font-semibold text-gray-800">PARTIES:</h2>
               <div className="pl-4">
                  <p className="font-medium">DEVELOPER: Mark Gilbert Reginio</p>
                  <p>Contact: 09760575662 / markgilbertreginio96204@gmail.com</p>
                  <p>Address: Matuyatuya, Torrijos, Marinduque</p>
               </div>
               <div className="pl-4">
                  <p className="font-medium">CLIENT: Department of Environment and Natural Resources - Provincial Environment and Natural Resources Office (DENR-PENRO) Marinduque</p>
                  <p>Address: Boac, Marinduque</p>
                  <p>Represented by: [DENR-PENRO representative]</p>
               </div>
            </div>

            {/* System Cost and Payment */}
            <div className="space-y-4">
               <h2 className="text-xl font-semibold text-gray-800">1. SYSTEM COST AND PAYMENT</h2>

               <div className="pl-4 space-y-4">
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">1.1. System acquisition cost: To be finalized upon contract signing</h3>
                     <div className="pl-4 mt-2 space-y-2">
                        <p className="italic">Note: Final pricing will be determined based on:</p>
                        <div className="pl-4 space-y-2">
                           <div className="flex items-start">
                              <span className="text-gray-400 mr-2">•</span>
                              <p className="text-gray-700">System Complexity: Multi-user roles, workflow automation, document processing</p>
                           </div>
                           <div className="flex items-start">
                              <span className="text-gray-400 mr-2">•</span>
                              <p className="text-gray-700">Security Features: Role-based access, audit trails, data encryption</p>
                           </div>
                           <div className="flex items-start">
                              <span className="text-gray-400 mr-2">•</span>
                              <p className="text-gray-700">Custom Development: Tailored specifically for DENR-PENRO processes</p>
                           </div>
                           <div className="flex items-start">
                              <span className="text-gray-400 mr-2">•</span>
                              <p className="text-gray-700">Scale: Complete permit management system with 6 permit types</p>
                           </div>
                           <div className="flex items-start">
                              <span className="text-gray-400 mr-2">•</span>
                              <p className="text-gray-700">Development Effort: 10 months of development, 147,403 lines of code</p>
                           </div>
                           <div className="flex items-start">
                              <span className="text-gray-400 mr-2">•</span>
                              <p className="text-gray-700">Integration Capabilities: Ready for future DENR system integrations</p>
                           </div>
                        </div>
                        <p className="mt-2">The final price will reflect the system's value and market standards for similar government systems</p>
                     </div>
                  </div>

                  <div>
                     <h3 className="text-lg font-medium text-gray-800">1.2. Payment Terms:</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Payment shall be made directly to the DEVELOPER (Mark Gilbert Reginio) only</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">No third-party payments or intermediaries are authorized</p>
                        </div>
                        <p className="mt-2">Payment options available:</p>
                        <div className="pl-8">
                           <p>a) Full payment upon contract signing</p>
                           <p>b) Initial down payment followed by installment payments</p>
                        </div>
                        <p className="mt-2">Required documentation will be provided:</p>
                        <div className="pl-8">
                           <p>a) Official Receipt/Invoice</p>
                           <p>b) Delivery Receipt</p>
                           <p>c) Other necessary documentation as required</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Additional Features and Modifications */}
            <div className="space-y-4">
               <h3 className="text-lg font-medium text-gray-800">1.3. Additional Features and Modifications:</h3>
               <div className="pl-4 space-y-2">
                  <div className="flex items-start">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">Additional features or modifications requested shall be subject to separate cost assessment</p>
                  </div>
                  <div className="flex items-start">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">Each new feature request will be evaluated and quoted separately</p>
                  </div>
                  <p className="mt-2">DEVELOPER reserves the right to reject any feature request that:</p>
                  <div className="pl-8">
                     <p>a) Is technically unfeasible</p>
                     <p>b) Conflicts with system architecture</p>
                     <p>c) Compromises system security or stability</p>
                     <p>d) Falls outside the system's intended scope</p>
                  </div>
                  <div className="flex items-start mt-2">
                     <span className="text-gray-400 mr-2">•</span>
                     <p className="text-gray-700">Implementation will begin only after written approval and payment terms are agreed upon</p>
                  </div>
               </div>
            </div>

            {/* Ownership and Rights */}
            <div className="space-y-4">
               <h2 className="text-xl font-semibold text-gray-800">2. OWNERSHIP AND RIGHTS</h2>

               <div className="pl-4 space-y-4">
                  {/* Pre-Contract Period */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">2.1. Pre-Contract Period:</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">System and source code remain property of DEVELOPER</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Unauthorized use or modification is prohibited</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">System URL listing in DENR's systems is permitted for reference only</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Such listing does not constitute or imply any transfer of ownership rights</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">System may not be claimed or listed as CLIENT property</p>
                        </div>
                     </div>
                  </div>

                  {/* Upon Contract Signing */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">2.2. Upon Contract Signing:</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Full ownership of system and source code transfers to CLIENT</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">CLIENT receives all intellectual property rights</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">CLIENT gains complete control over system modifications and updates</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">System listing can be updated to reflect CLIENT ownership</p>
                        </div>
                     </div>
                  </div>

                  {/* DEVELOPER's Retained Rights */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">2.3. DEVELOPER's Retained Rights:</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Right to showcase the system in portfolio</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Right to access the system for portfolio demonstration</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Right to use system architecture concepts in future projects</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Right to list DENR-PENRO as a client</p>
                        </div>
                     </div>
                  </div>

                  {/* Additional Terms */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">2.4. Additional Terms:</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">System branding may be modified by CLIENT after ownership transfer</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">CLIENT may engage any developer for future modifications</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">CLIENT may transfer system to other DENR offices</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">DEVELOPER's portfolio rights survive any system transfer or modification</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Warranty and Liability */}
            <div className="space-y-4">
               <h2 className="text-xl font-semibold text-gray-800">3. WARRANTY AND LIABILITY</h2>

               <div className="pl-4 space-y-4">
                  {/* Warranty Period and Coverage */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">3.1. Warranty Period and Coverage</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">60-day warranty period from contract signing</p>
                        </div>
                        <p className="mt-2">During warranty period:</p>
                        <div className="pl-8">
                           <p>a) Technical support for critical issues</p>
                           <p>b) Essential security updates</p>
                           <p>c) Bug fixes for core functionality</p>
                        </div>
                        <div className="flex items-start mt-2">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Covers core functionality only</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Does not cover changes in business requirements</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Excludes issues caused by client modifications</p>
                        </div>
                     </div>
                  </div>

                  {/* Post-Warranty Period */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">3.2. Post-Warranty Period</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">No technical support or updates provided</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Infrastructure to be managed by CLIENT or their chosen third-party provider</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Additional support requires new agreement</p>
                        </div>
                     </div>
                  </div>

                  {/* Warranty Exclusions */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">3.3. Warranty Exclusions</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Third-party service disruptions</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Force majeure events</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Unauthorized modifications</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Misuse or negligence</p>
                        </div>
                     </div>
                  </div>

                  {/* Limitation of Liability */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">3.4. Limitation of Liability</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Developer's liability limited to amount paid for system</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">No liability for consequential damages</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Force majeure clause applies</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Client responsible for data accuracy</p>
                        </div>
                     </div>
                  </div>

                  {/* Indemnification */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">3.5. Indemnification</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Client indemnifies developer against misuse</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Developer indemnifies against IP claims</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Mutual indemnification for gross negligence</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* General Provisions */}
            <div className="space-y-4">
               <h2 className="text-xl font-semibold text-gray-800">4. GENERAL PROVISIONS</h2>

               <div className="pl-4 space-y-4">
                  {/* Governing Law */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">4.1. Governing Law</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">This agreement is governed by Philippine law</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Legal proceedings shall be filed with RTC Branch 38, Boac, Marinduque</p>
                        </div>
                     </div>
                  </div>

                  {/* Changes and Notices */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">4.2. Changes and Notices</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Changes to this agreement must be agreed upon in writing</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Regular communications can be done through email</p>
                        </div>
                     </div>
                  </div>

                  {/* Agreement Transfer */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">4.3. Agreement Transfer</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Final agreement will be drafted by legal counsel</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">This preliminary agreement will be superseded by notarized contract</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Confidentiality */}
            <div className="space-y-4">
               <h2 className="text-xl font-semibold text-gray-800">5. CONFIDENTIALITY</h2>

               <div className="pl-4 space-y-4">
                  {/* Confidential Information */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">5.1. Confidential Information</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Source code and architecture</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Business processes and data</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Security measures and credentials</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Client information and usage patterns</p>
                        </div>
                     </div>
                  </div>

                  {/* Protection Measures */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">5.2. Protection Measures</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Need-to-know basis access</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Secure storage requirements</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">No unauthorized copies</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Return/destruction upon termination</p>
                        </div>
                     </div>
                  </div>

                  {/* Duration */}
                  <div>
                     <h3 className="text-lg font-medium text-gray-800">5.3. Duration</h3>
                     <div className="pl-4 space-y-2">
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Survives termination by 5 years</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Permanent for trade secrets</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Immediate breach notification</p>
                        </div>
                        <div className="flex items-start">
                           <span className="text-gray-400 mr-2">•</span>
                           <p className="text-gray-700">Injunctive relief available</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Final Note */}
            <div className="bg-green-50/50 p-4 rounded-lg mt-8">
               <p className="text-gray-800 italic">
                  This is a preliminary version of the agreement. Upon mutual acceptance of terms by both parties, a final version will be drafted by legal counsel and notarized to create a legally binding contract.
               </p>
            </div>
         </div>
      </div>
   );
};

export default SystemAgreementDisplay;